import "./App.css";

import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, Switch } from "react-router-dom";

toast.configure({
	position: "bottom-center",
	autoClose: 1500,
	newestOnTop: false,
	closeOnClick: true,
	rtl: false,
	pauseOnVisibilityChange: false,
	draggable: false,
	pauseOnHover: false,
	toastClassName: "copy-toast",
	bodyClassName: "copy-toast-body"
});

const App = ({ routes, initialData }) => {
	return routes ? (
		<div className="App">
			<Switch>
				{routes.map((route, index) => {
					return (
						<Route
							key={index}
							path={route.path}
							exact={route.exact}
							render={props =>
								React.createElement(route.component, {
									...props,
									identifier: route.name,
									requireAuth: route.requireAuth,
									initialData: initialData[index] || null
								})
							}
						/>
					);
				})}
			</Switch>
		</div>
	) : null;
};

export default App;
